import React, { useEffect, useState } from "react";
import logo from "../../assets/Images/logo.png";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaXmark, FaPhone } from "react-icons/fa6";
import { app_url } from "../../config";
import RequestCallback from "../Booking/RequestCallback";

const Navbar = () => {
  const [stickyNavbar, setStickyNavbar] = useState(false);
  const [mobileNavbar, setMobileNavbar] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 550) {
        setStickyNavbar(true);
      } else {
        setStickyNavbar(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <nav className={`navibar stickyNav border-bottom ${stickyNavbar ? "sticky" : ""}`}>
      <div className="auto-container position-relative">
        <div className="navbar-content d-flex align-items-center justify-content-between py-2 rounded-3">
          <div className="navbar-logo">
            <Link to={app_url} className="navbar-brand" onClick={() => window.scrollTo(0, 0)}>
              <img src={logo} alt="Logo" width="175" />
            </Link>
          </div>

          <ul className={`navlinks ms-md-5 ${mobileNavbar ? "show_navbar" : ""}`}>
            <li onClick={() => window.scrollTo(0, 0)}>
              <Link to={app_url}>Home</Link>
            </li>
            <li>
              <a href="#our-services">Services</a>
            </li>
            <li>
              <a href="#about-us">About Us</a>
            </li>
            <li>
              <a href="#portfolio">Portfolio</a>
            </li>
            <li className="phone-link d-flex align-items-center">
              <a href="tel:+07767426142" className="phone-anchor">
                <FaPhone className="phone-icon" />
                <span>(0) 7767 426142</span>
              </a>
            </li>
          </ul>

          <div className="d-flex align-items-center">
            <RequestCallback btn_text={"Book a Call"} />
            <button
              className="menu_btn ms-4"
              aria-label="menu_btn"
              onClick={() => setMobileNavbar((prev) => !prev)}
            >
              {mobileNavbar ? <FaXmark /> : <FaBars />}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
